/*
 * Copyright (c) 2018 Barclays PLC.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Barclays PLC.
 * ("Confidential Information").
 *
 * File: directMailerCheckYourRatePage.js
 * Created: Oct 25, 2018
 */

import React from 'react';
import { connect } from 'react-redux';
import ProgressBar from '../progress.bar';
import PropTypes from 'prop-types';
import { Redirect } from "react-router-dom";
import { getProspect, getLoanApplication, getLandingCode } from '../../selectors';
import Section from '../Section/section';
import CheckYourRateForm from "../LoanApplication/CheckYourRateForm/checkYourRateForm";
import LoanApplicationHeader from '../LoanApplication/LoanApplicationHeader/loanApplicationHeader';
import { isEmpty } from "ramda";
import { backButtonToLandingPage } from '../../actions';
import { LandingCodes } from '../../landingCodes';

export class DirectMailerCheckYourRatePage extends React.Component {

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render = () => {
    const { prospect, loanApplication, landingCode, backButtonToLandingPage } = this.props;
    if (!prospect || (loanApplication.quotes && !isEmpty(loanApplication.quotes))) {
      backButtonToLandingPage();
      if(window.isToggleOn('cl_aa_cobranding')) {
        if(landingCode === LandingCodes.AADVANTAGE) {
          return <Redirect to="/apply/invitation/american" />;
        }
      }
      return <Redirect to="/apply/invitation" />;
    }

    return (
      <article>
        <LoanApplicationHeader title={`Nice to see you, ${prospect.name.firstName}`}>
          <ul>
            <h2/>
            <li>
              <p>We just need a bit more information.</p>
            </li>
          </ul>
        </LoanApplicationHeader>
        <Section>
          <header>
            <ProgressBar step="miniApp"/>
            <p className="font-weight-normal">Please fill in the fields below.</p>
          </header>
          <CheckYourRateForm/>
        </Section>
      </article>
    );
  }
}

const mapStateToProps = state => ({
  prospect: getProspect(state),
  loanApplication: getLoanApplication(state),
  landingCode: getLandingCode(state)
});

const mapDispatchToProps = { backButtonToLandingPage };

export default connect(mapStateToProps, mapDispatchToProps)(DirectMailerCheckYourRatePage);

DirectMailerCheckYourRatePage.propTypes = {
  prospect: PropTypes.shape({
    name: PropTypes.shape({
      firstName: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
